import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { ASCENDER } from '../../data/retiro';
export function Ascender() {
  return <section className="relative w-full overflow-hidden px-5 py-24 sm:px-8 sm:py-32" style={{
    backgroundColor: 'var(--ink)'
  }} data-id="element-60" data-mp="152pshhbjh5vp">
      <div className="mx-auto max-w-5xl" data-id="element-61" data-mp="w32qatazjw1l">
        <SectionHeading eyebrow="La invitación" title="Ascender, no trascender" subtitle="Ascender no es irte de aquí: es ocupar por fin todo el espacio que tu alma vino a habitar. Más claridad, más potencia, más presencia. Este retiro es el umbral." light data-id="element-62" data-mp="w44d1v1d66z5" />

        <Reveal delay={0.1} data-id="element-63" data-mp="hfzt6nqkrpes">
          <p className="mx-auto mt-8 max-w-3xl text-center text-base leading-relaxed text-white/70" data-id="element-64" data-mp="hclp9b29j858">
            Tu potencial espiritual no es una promesa futura: es una capacidad
            que ya vive en ti y que los nudos mantienen a media luz. Cuando el
            hilo se suelta, la energía que usabas para sostenerlo vuelve a su
            lugar — y empiezas a crear desde el alma, no desde el esfuerzo.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-5 sm:grid-cols-2" data-id="element-65" data-mp="1bdwxuq3y7hlu">
          {ASCENDER.map((item, i) => <Reveal key={item.titulo} delay={i * 0.08} data-id="element-66" data-mp="1gd042dvnztve" data-mpi={i}>
              <div className="flex h-full items-start gap-4 rounded-2xl border border-white/10 bg-white/[0.03] p-6" data-id="element-67" data-mp="241jccteps6nh">
                <SparklesIcon className="mt-0.5 h-5 w-5 shrink-0" style={{
              color: 'var(--jasmine)'
            }} data-id="element-68" data-mp="2915p71qmrkvr" />
                <div data-id="element-69" data-mp="1z26eldmb1f64">
                  <p className="font-medium text-white" data-id="element-70" data-mp="1z1etiwqc2zu3">{item.titulo}</p>
                  <p className="mt-1 text-sm leading-relaxed text-white/75" data-id="element-71" data-mp="jlxsjd4x32gj">
                    {item.texto}
                  </p>
                </div>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={0.2} data-id="element-72" data-mp="2qa7xave6k47n">
          <blockquote className="mx-auto mt-12 max-w-2xl border-l-2 pl-5 font-heading text-lg font-light italic leading-relaxed text-white/85" style={{
          borderColor: 'var(--jasmine)'
        }} data-id="element-73" data-mp="2q9f12ocukx3r">
            "Esto se trata de ascender, no de trascender. La vida tiene más para
            ti aquí."
          </blockquote>
        </Reveal>
      </div>
    </section>;
}